import UserWorkspaceList from './UserWorkspaceList';
export default UserWorkspaceList;